"use client";
import { connectorsForWallets } from "@rainbow-me/rainbowkit";
import {
  argentWallet,
  coinbaseWallet,
  ledgerWallet,
  metaMaskWallet,
  rabbyWallet,
  rainbowWallet,
  safeWallet,
  walletConnectWallet,
} from "@rainbow-me/rainbowkit/wallets";
import { createConfig, http } from "wagmi";
import {
  mainnet,
  polygon,
  bsc,
  bscTestnet,
  fantom,
  optimism,
  fantomTestnet,
  arbitrum,
} from "wagmi/chains";

const projectId = process.env.REACT_APP_WALLETCONNECT_PROJECT_ID
  ? process.env.REACT_APP_WALLETCONNECT_PROJECT_ID
  : "b5f312785aa6c0470de515524494aeef";
const isProdEnv = process.env.REACT_APP_NODE_ENV === "production";

if (!projectId) {
  throw new Error("WalletConnect Project ID is not defined");
}

const connectors = connectorsForWallets(
  [
    {
      groupName: "Other",
      wallets: [
        metaMaskWallet,
        rainbowWallet,
        walletConnectWallet,
        ledgerWallet,
        rabbyWallet,
        coinbaseWallet,
        argentWallet,
        safeWallet,
      ],
    },
  ],
  {
    appName: "Finexim-Bank",
    projectId: projectId,
    appUrl: process.env.REDIRECT_URI,
  }
);

const customFantom = { ...fantom, iconUrl: "/images/favcion.png" };
// const customfantomTestnet = {
//   ...fantomTestnet,
//   iconUrl: "/images/favcion.png",
// };

const transports = isProdEnv
  ? {
      [bsc.id]: http(),
    }
  : {
      // [bscTestnet.id]: http(),
      [bsc.id]: http(),
    };

export const wagmiConfig = createConfig({
  chains: isProdEnv
    ? [bsc]
    : [
        // bscTestnet,
        bsc,
      ],
  connectors,
  transports,
  ssr: false,
});
